import { c as _c } from "react/compiler-runtime";
import React, { type JSX } from 'react';
import { Tooltip } from 'shared/components';
import { ChartCard } from 'shared/components/chart/chart-card';
import { ChartTrendBadge } from 'shared/components/chart/chart-trend-badge';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { isYesterday } from 'shared/utils/date-time-format';
export interface ChartBoxProps {
  title: string;
  total: string;
  diffPercents: number;
  countDays: number;
  dateSince: string | null;
  chart: JSX.Element;
}
const ChartBox = t0 => {
  const $ = _c(17);
  const {
    title,
    total,
    diffPercents,
    countDays,
    dateSince,
    chart
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    user
  } = useUser();
  const positiveDiff = diffPercents >= 0;
  let t1;
  if ($[0] !== countDays || $[1] !== dateSince || $[2] !== t || $[3] !== user?.timezone) {
    t1 = isYesterday(dateSince, user?.timezone) && countDays === 1 ? t("dashboard.main.one_day_ago").toLowerCase() : t("dashboard.main.last_days", {
      count: countDays
    }).toLowerCase();
    $[0] = countDays;
    $[1] = dateSince;
    $[2] = t;
    $[3] = user?.timezone;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const t2 = positiveDiff ? "up" : "down";
  const t3 = positiveDiff ? "success" : "error";
  let t4;
  if ($[5] !== diffPercents || $[6] !== t2 || $[7] !== t3) {
    t4 = <ChartTrendBadge direction={t2} tone={t3}>{diffPercents}%</ChartTrendBadge>;
    $[5] = diffPercents;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t1 || $[10] !== t4) {
    t5 = <Tooltip label={t1}>{t4}</Tooltip>;
    $[9] = t1;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== chart || $[13] !== t5 || $[14] !== title || $[15] !== total) {
    t6 = <ChartCard className="tablet:w-[calc(50%-10px)] desktop:w-[calc(50%-10px)] h-[340px]" title={title} value={total} headerAction={t5}>{chart}</ChartCard>;
    $[12] = chart;
    $[13] = t5;
    $[14] = title;
    $[15] = total;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
};
export default ChartBox;